import { CompanyData } from '@types';
import { CompanyFormData } from './company-form';
import { OrtPeriod } from './company-ort-form';

export const companyDataPrepareForSubmit = (data: CompanyFormData): CompanyData => {
  const { receiptCertificates, ...rest } = data;
  const processedData = {
    ...rest,
    maxFLTravelAllowanceCents: toCentsOrUndefined(data.maxFLTravelAllowance),
    maxParkingCents: toCentsOrUndefined(data.maxParking),
    maxTWTravelAllowanceCents: toCentsOrUndefined(data.maxTWTravelAllowance),
    maxMileageAllowanceMeters: toNumberOrUndefined(data.maxMileageAllowance),
    receiptCertificateIds: receiptCertificates?.map((certificate) => certificate.id) ?? [],
  };

  return processedData;
};

const toNumberOrUndefined = (value: string | number | undefined): number | undefined => {
  if (value === '' || value === undefined) {
    return undefined;
  }
  return Number(value);
};

const toCentsOrUndefined = (value: string | number | undefined): number | undefined => {
  const numericValue = toNumberOrUndefined(value);
  return numericValue !== undefined ? numericValue * 100 : undefined;
};

export const formatTimeToUi = (time: string) => {
  const formattedTime = time.slice(0, 5);
  return formattedTime === '24:00' ? '23:59' : formattedTime;
};

export const formatTimeToBackend = (time: string) => {
  const formattedTime = time === '23:59' ? '24:00' : time;
  return `${formattedTime}:00`;
};

export function formatOrtPeriods(periods: OrtPeriod[]): any[] {
  return periods.map((period) => ({
    startTime: formatTimeToBackend(period.startTime || '00:00'),
    endTime: formatTimeToBackend(period.endTime || '24:00'),
    percentage: !period.percentage ? null : Number(period.percentage),
  }));
}
